<template>
  <div class="text" v-if="sanitizedText" ref="text">
    {{ sanitizedText }}
  </div>
</template>

<script>
export default {
  props: ['post', 'source'],

  data() {
    return {
      sanitizedText: null,
      hashtags: [],
      maxLength: 180
    };
  },

  created() {
    this.trimUrls();
    this.extractHashtags();
    this.trimLengh();
    this.$emit('updateHashtags', this.hashtags);
  },

  methods: {
    trimUrls() {
      this.sanitizedText = this.rawText
        .replace(/(?:https?|ftp):\/\/[\n\S]+/g, '')
        .trim();
    },

    trimLengh() {
      if (this.sanitizedText.length > this.maxLength) {
        this.sanitizedText = this.sanitizedText.substring(0, this.maxLength);
        this.sanitizedText += '...';
      }
    },

    extractHashtags() {
      const tags = this.rawText.match(/#[a-zA-Z]+/gi);
      // allow a maximum of 10 tags per post
      this.hashtags = tags.slice(0, 7);
    }
  },

  computed: {
    rawText() {
      switch (this.source) {
        case 'twitter':
          return this.post.full_text ? this.post.full_text : this.post.comment;
        case 'instagram':
          return this.post.edge_media_to_caption
            ? this.post.edge_media_to_caption.edges[0].node.text
            : this.post.comment;
        case 'wallsio':
          return this.post.comment;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.text {
  transition: all 0.7s ease-in-out;
  transform: translateX(50vw);
  z-index: 0;

  .post.active & {
    transform: translateX(0);
    opacity: 1;

    .display-sponsor & {
      transform: translateX(50vw);
    }
  }

  .post.prev & {
    transform: translateX(50vw);
    opacity: 0;
  }

  .post.next & {
    transform: translateX(-50vw);
    opacity: 0;
  }
}
</style>
